import apiClient from '../api';
import { CoachAthleteNote, CreateCoachNoteRequest, UpdateCoachNoteRequest } from '../../types';

const coachNotesService = {
  getAthleteNotes: async (athleteUserId: string): Promise<CoachAthleteNote[]> => {
    const response = await apiClient.get<CoachAthleteNote[]>(`/coach/athlete-notes/${athleteUserId}`);
    return response.data;
  },

  createNote: async (data: CreateCoachNoteRequest): Promise<CoachAthleteNote> => {
    const response = await apiClient.post<CoachAthleteNote>('/coach/athlete-notes', data);
    return response.data;
  },

  updateNote: async (noteId: string, data: UpdateCoachNoteRequest): Promise<CoachAthleteNote> => {
    const response = await apiClient.put<CoachAthleteNote>(`/coach/athlete-notes/${noteId}`, data);
    return response.data;
  },

  deleteNote: async (noteId: string): Promise<void> => {
    await apiClient.delete(`/coach/athlete-notes/${noteId}`);
  },
};

export default coachNotesService;
